module.exports = __webpack_public_path__ + "static/media/logo.8061027b.svg";